import each from 'lodash/each';

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getPds, getPdsRanges } from 'store/scenes/distributions/pds/selectors';
import { getGraphTicks } from 'store/scenes/distributions/graphTicks/selectors';

import {
  getTailType,
  isLeftTailSelected,
  isRightTailSelected
} from 'store/scenes/distributions/chart/selectors';

import { getCutoffs } from 'store/scenes/distributions/cutoffs/selectors';

import LineChartComponent from './Component';

class LineChartContainer extends React.PureComponent {
  static propTypes = {
    pds: PropTypes.arrayOf(
      PropTypes.shape({
        x: PropTypes.number.isRequired,
        y: PropTypes.number.isRequired
      }).isRequired
    ),

    ranges: PropTypes.shape({
      x: PropTypes.shape({
        min: PropTypes.number,
        max: PropTypes.number
      }).isRequired,

      y: PropTypes.shape({
        min: PropTypes.number,
        max: PropTypes.number
      }).isRequired
    }),

    cutoffs: PropTypes.shape({
      left: PropTypes.object.isRequired,
      right: PropTypes.object.isRequired
    }).isRequired,

    leftTailSelected: PropTypes.bool.isRequired,
    rightTailSelected: PropTypes.bool.isRequired,
    centerTailsSelected: PropTypes.bool.isRequired,

    graphTicks: PropTypes.array
  }

  chartTailChunkClassName (isVisible, colorCenter) {
    return isVisible && !colorCenter ? 'orange' : 'blue';
  }

  get paths () {
    const middleChunk = [];
    const chunk = [];
    const downChunk = [];
    const leftTailChunk = [];
    const rightTailChunk = [];

    const {
      cutoffs: {
        left: leftCutoff,
        right: rightCutoff
      },
      ranges: {
        x: { min, max }
      }
    } = this.props;

    if (!(leftCutoff.x <= min || leftCutoff.x >= max)) {
      this.props.centerTailsSelected ? downChunk.push({ x: leftCutoff.x, y: 0 }) : downChunk.push();
    }

    each(this.props.pds, pd => {
      if (pd.x <= leftCutoff.x) {
        leftTailChunk.push(pd);
      }

      if (pd.x >= rightCutoff.x) {
        rightTailChunk.push(pd);
      }

      if (pd.x >= leftCutoff.x && pd.x <= rightCutoff.x) {
        middleChunk.push(pd);
        this.props.centerTailsSelected ? downChunk.push({ x: pd.x, y: pd.y }) : downChunk.push();
      }
    });

    // Prevent building paths outside the ranges
    if (!(leftCutoff.x <= min || leftCutoff.x >= max)) {
      if (!(rightCutoff.x <= min || rightCutoff.x >= max)) {
        leftTailChunk.push(leftCutoff);

        if (middleChunk.length > 0) {
          middleChunk.unshift(leftCutoff);
          middleChunk.push(rightCutoff);
        }

        rightTailChunk.unshift(rightCutoff);
      }
    }


    const paths = [
      {
        points: leftTailChunk,
        className:
          this.chartTailChunkClassName(
            this.props.leftTailSelected, this.props.centerTailsSelected
          )
      },
      {
        points: middleChunk,
        className: 'blue'
      },
      {
        points: this.props.centerTailsSelected ? downChunk : chunk,
        className: 'orange'
      },
      {
        points: rightTailChunk,
        className:
          this.chartTailChunkClassName(
            this.props.rightTailSelected, this.props.centerTailsSelected
          )
      }
    ];

    return this.props.leftTailSelected
      ? paths.reverse()
      : paths;
  }

  // Prevent building nodes outside the ranges
  get nodes () {
    const { cutoffs, leftTailSelected, rightTailSelected } = this.props;

    return [
      ...(leftTailSelected ? [cutoffs.left] : []),
      ...(rightTailSelected ? [cutoffs.right] : [])
    ];
  }

  render () {
    if (!this.props.ranges) {
      return null;
    }

    return (
      <LineChartComponent
        paths={this.paths}
        nodes={this.nodes}
        ranges={this.props.ranges}
        graphTicks={this.props.graphTicks}
      />
    );
  }
}

const mapStateToProps = state => ({
  pds: getPds(state),
  cutoffs: getCutoffs(state),
  ranges: getPdsRanges(state),
  graphTicks: getGraphTicks(state),
  leftTailSelected: isLeftTailSelected(state),
  rightTailSelected: isRightTailSelected(state),
  centerTailsSelected: getTailType(state) === 'center'
});

export default connect(mapStateToProps, null)(
  LineChartContainer
);
